"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESicurezzaAntincendio = exports.EMisureEControlli = exports.EstinguentiDescriptions = exports.DpiDescriptions = exports.AttivitaAltoRischioDescriptions = exports.IAttivitaAltoRischio = exports.ehsStatusMap = exports.EEhsStatus = exports.EEhsMaintenanceType = exports.EEhsType = void 0;
const IUserGroups_1 = require("./IUserGroups");
const EUserRoles_1 = require("./EUserRoles");
var EEhsType;
(function (EEhsType) {
    EEhsType["SITO"] = "0";
    EEhsType["MAINTENANCE"] = "1";
})(EEhsType = exports.EEhsType || (exports.EEhsType = {}));
var EEhsMaintenanceType;
(function (EEhsMaintenanceType) {
    EEhsMaintenanceType["STANDARD"] = "0";
    EEhsMaintenanceType["SPAZI_CONFINATI"] = "1";
})(EEhsMaintenanceType = exports.EEhsMaintenanceType || (exports.EEhsMaintenanceType = {}));
var EEhsStatus;
(function (EEhsStatus) {
    EEhsStatus[EEhsStatus["NUOVO"] = 0] = "NUOVO";
    EEhsStatus[EEhsStatus["ACCETTAZIONE_R"] = 10] = "ACCETTAZIONE_R";
    EEhsStatus[EEhsStatus["ACCETTAZIONE_N"] = 20] = "ACCETTAZIONE_N";
    EEhsStatus[EEhsStatus["ACCETTAZIONE_Y"] = 30] = "ACCETTAZIONE_Y";
    EEhsStatus[EEhsStatus["CHIUSURA_Y"] = 40] = "CHIUSURA_Y";
    EEhsStatus[EEhsStatus["CANCELLATO"] = 100] = "CANCELLATO";
})(EEhsStatus = exports.EEhsStatus || (exports.EEhsStatus = {}));
exports.ehsStatusMap = {
    [EEhsStatus.NUOVO]: {
        roles: (ehsType = EEhsType.SITO, maintenanceType) => {
            switch (ehsType) {
                case EEhsType.MAINTENANCE:
                    return maintenanceType === EEhsMaintenanceType.SPAZI_CONFINATI
                        ? [EUserRoles_1.EUserRoles.EhsMaintenanceManager, EUserRoles_1.EUserRoles.EhsMaintenanceExternalCompanyPlus]
                        : [
                            EUserRoles_1.EUserRoles.EhsMaintenanceManager,
                            EUserRoles_1.EUserRoles.EhsMaintenanceBasic,
                            EUserRoles_1.EUserRoles.EhsMaintenanceExternalCompany,
                            EUserRoles_1.EUserRoles.EhsMaintenanceExternalCompanyPlus,
                        ];
                case EEhsType.SITO:
                    return [EUserRoles_1.EUserRoles.EhsManager, EUserRoles_1.EUserRoles.EhsApplicant];
            }
        },
        roleToNotify: () => [],
        next: [EEhsStatus.ACCETTAZIONE_R, EEhsStatus.CANCELLATO],
        editableFields: [],
        name: 'New',
    },
    [EEhsStatus.ACCETTAZIONE_R]: {
        roles: (ehsType = EEhsType.SITO, maintenanceType) => {
            switch (ehsType) {
                case EEhsType.MAINTENANCE:
                    return [EUserRoles_1.EUserRoles.EhsMaintenanceManager, EUserRoles_1.EUserRoles.EhsMaintenanceBasic];
                case EEhsType.SITO:
                    return [EUserRoles_1.EUserRoles.EhsManager];
            }
        },
        roleToNotify: (ehsType = EEhsType.SITO, maintenanceType) => {
            switch (ehsType) {
                case EEhsType.MAINTENANCE:
                    return [EUserRoles_1.EUserRoles.EhsMaintenanceManager, EUserRoles_1.EUserRoles.EhsMaintenanceBasic];
                case EEhsType.SITO:
                    return [EUserRoles_1.EUserRoles.EhsManager];
            }
        },
        next: [EEhsStatus.ACCETTAZIONE_N, EEhsStatus.CANCELLATO],
        editableFields: [],
        name: 'Pending acceptance',
    },
    [EEhsStatus.ACCETTAZIONE_N]: {
        roles: (ehsType = EEhsType.SITO, maintenanceType) => {
            switch (ehsType) {
                case EEhsType.MAINTENANCE:
                    return [
                        EUserRoles_1.EUserRoles.EhsMaintenanceManager,
                        EUserRoles_1.EUserRoles.EhsMaintenanceBasic,
                        EUserRoles_1.EUserRoles.EhsMaintenanceExternalCompany,
                        EUserRoles_1.EUserRoles.EhsMaintenanceExternalCompanyPlus,
                    ];
                case EEhsType.SITO:
                    return [EUserRoles_1.EUserRoles.EhsManager, EUserRoles_1.EUserRoles.EhsApplicant];
            }
        },
        roleToNotify: (ehsType = EEhsType.SITO, maintenanceType) => {
            switch (ehsType) {
                case EEhsType.MAINTENANCE:
                    return [EUserRoles_1.EUserRoles.EhsMaintenanceManager, EUserRoles_1.EUserRoles.EhsMaintenanceBasic];
                case EEhsType.SITO:
                    return [EUserRoles_1.EUserRoles.EhsManager, EUserRoles_1.EUserRoles.EhsApplicant];
            }
        },
        next: [EEhsStatus.ACCETTAZIONE_R, EEhsStatus.CANCELLATO],
        editableFields: [],
        name: 'Rejected',
    },
    [EEhsStatus.ACCETTAZIONE_Y]: {
        roles: (ehsType = EEhsType.SITO, maintenanceType) => {
            switch (ehsType) {
                case EEhsType.MAINTENANCE:
                    return maintenanceType === EEhsMaintenanceType.SPAZI_CONFINATI
                        ? [EUserRoles_1.EUserRoles.EhsMaintenanceManager, EUserRoles_1.EUserRoles.EhsMaintenanceExternalCompanyPlus]
                        : [
                            EUserRoles_1.EUserRoles.EhsMaintenanceManager,
                            EUserRoles_1.EUserRoles.EhsMaintenanceBasic,
                            EUserRoles_1.EUserRoles.EhsMaintenanceExternalCompany,
                            EUserRoles_1.EUserRoles.EhsMaintenanceExternalCompanyPlus,
                        ];
                case EEhsType.SITO:
                    return [EUserRoles_1.EUserRoles.EhsManager, EUserRoles_1.EUserRoles.EhsApplicant];
            }
        },
        roleToNotify: (ehsType = EEhsType.SITO, maintenanceType) => {
            switch (ehsType) {
                case EEhsType.MAINTENANCE:
                    if (maintenanceType === EEhsMaintenanceType.STANDARD) {
                        return [EUserRoles_1.EUserRoles.EhsMaintenanceManager, EUserRoles_1.EUserRoles.EhsMaintenanceBasic];
                    }
                    else {
                        return [EUserRoles_1.EUserRoles.EhsMaintenanceManager];
                    }
                case EEhsType.SITO:
                    return [EUserRoles_1.EUserRoles.EhsManager, EUserRoles_1.EUserRoles.EhsApplicant];
            }
        },
        sendReminder: [IUserGroups_1.EUserGroup.PTW_ISSUER],
        next: [EEhsStatus.CHIUSURA_Y, EEhsStatus.CANCELLATO],
        editableFields: [],
        name: 'Accepted',
    },
    [EEhsStatus.CHIUSURA_Y]: {
        roles: () => [],
        roleToNotify: () => [EUserRoles_1.EUserRoles.EhsManager, EUserRoles_1.EUserRoles.EhsApplicant],
        next: [EEhsStatus.CANCELLATO],
        editableFields: [],
        name: 'Closed',
    },
    [EEhsStatus.CANCELLATO]: {
        roles: (ehsType = EEhsType.SITO, maintenanceType) => {
            switch (ehsType) {
                case EEhsType.MAINTENANCE:
                    return [EUserRoles_1.EUserRoles.EhsMaintenanceManager, EUserRoles_1.EUserRoles.EhsMaintenanceBasic];
                case EEhsType.SITO:
                    return [EUserRoles_1.EUserRoles.EhsManager, EUserRoles_1.EUserRoles.EhsApplicant];
            }
        },
        roleToNotify: (ehsType = EEhsType.SITO, maintenanceType) => {
            switch (ehsType) {
                case EEhsType.MAINTENANCE:
                    return [EUserRoles_1.EUserRoles.EhsMaintenanceManager, EUserRoles_1.EUserRoles.EhsMaintenanceBasic];
                case EEhsType.SITO:
                    return [EUserRoles_1.EUserRoles.EhsManager, EUserRoles_1.EUserRoles.EhsApplicant];
            }
        },
        next: [],
        editableFields: [],
        name: 'Deleted',
    },
};
var IAttivitaAltoRischio;
(function (IAttivitaAltoRischio) {
    IAttivitaAltoRischio["atex"] = "atex";
    IAttivitaAltoRischio["esposizioneARadiazioni"] = "esposizioneARadiazioni";
    IAttivitaAltoRischio["lavoriACaldo"] = "lavoriACaldo";
    IAttivitaAltoRischio["lavoriAcquatici"] = "lavoriAcquatici";
    IAttivitaAltoRischio["lavoriDiScavo"] = "lavoriDiScavo";
    IAttivitaAltoRischio["lavoriInQuota"] = "lavoriInQuota";
    IAttivitaAltoRischio["lavoroIsolato"] = "lavoroIsolato";
    IAttivitaAltoRischio["loto"] = "loto";
    IAttivitaAltoRischio["montaggioImpalcature"] = "montaggioImpalcature";
    IAttivitaAltoRischio["movimentazioneVeicoli"] = "movimentazioneVeicoli";
    IAttivitaAltoRischio["operazioniDiSollevamento"] = "operazioniDiSollevamento";
    IAttivitaAltoRischio["operazioniSuPartiMeccaniche"] = "operazioniSuPartiMeccaniche";
    IAttivitaAltoRischio["sicurezzaElettrica"] = "sicurezzaElettrica";
    IAttivitaAltoRischio["sostanzePericolose"] = "sostanzePericolose";
    IAttivitaAltoRischio["spaziConfinati"] = "spaziConfinati";
    IAttivitaAltoRischio["recuperoFuoriWorkstation"] = "recuperoFuoriWorkstation";
})(IAttivitaAltoRischio = exports.IAttivitaAltoRischio || (exports.IAttivitaAltoRischio = {}));
exports.AttivitaAltoRischioDescriptions = {
    atex: 'Atex',
    esposizioneARadiazioni: 'Esposizione A Radiazioni',
    lavoriACaldo: 'Lavori A Caldo',
    lavoriAcquatici: 'Lavori Acquatici',
    lavoriDiScavo: 'Lavori Di Scavo',
    lavoriInQuota: 'Lavori In Quota',
    lavoroIsolato: 'Lavoro Isolato',
    loto: 'Loto',
    montaggioImpalcature: 'Montaggio Impalcature',
    movimentazioneVeicoli: 'Movimentazione Veicoli',
    operazioniDiSollevamento: 'Operazioni Di Sollevamento',
    operazioniSuPartiMeccaniche: 'Operazioni Su Parti Meccaniche',
    sicurezzaElettrica: 'Sicurezza Elettrica, lavori su apparecchiature alimentate, lavoro sotto tensione in bassa tensione',
    sostanzePericolose: 'Sostanze Pericolose',
    spaziConfinati: 'Spazi Confinati',
    recuperoFuoriWorkstation: 'Attività di recupero fuori Workstation',
};
exports.DpiDescriptions = {
    autorespiratore: 'Autorespiratore',
    stivaliSicurezza: 'Stivali sicurezza',
    scarpeAntinfortunistiche: 'Scarpe antinfortunistiche',
    elmetto: 'Elmetto',
    occhiali: 'Occhiali',
    guanti: 'Guanti',
    mascherinaPerPolveri: 'Mascherina per polveri',
    mascheraCarboniAttivi: 'Maschera carboni attivi',
    guantiRischioChimico: 'Guanti rischio chimico',
    tutaProtettiva: 'Tuta protettiva',
    guantiDielettrici: 'Guanti dielettrici',
};
exports.EstinguentiDescriptions = {
    estintoriAPolvere: 'Estintori a polvere',
    coperteAntifiamma: 'Coperte antifiamma',
    estintoriACO2: 'Estintori a CO2',
    cartellonistica: 'Cartellonistica/segnaletica specifica',
    estintoriCarrellati: 'Estintori carrellati',
    torciaDiSegnalazione: 'Torcia di segnalazione',
};
var EMisureEControlli;
(function (EMisureEControlli) {
    EMisureEControlli["alimentazioni"] = "alimentazioni";
    EMisureEControlli["paretiEPavimenti"] = "paretiEPavimenti";
    EMisureEControlli["isolamentoElettrico"] = "isolamentoElettrico";
    EMisureEControlli["bonificati"] = "bonificati";
    EMisureEControlli["delimitazione"] = "delimitazione";
    EMisureEControlli["ponteggi"] = "ponteggi";
    EMisureEControlli["antiscintilla"] = "antiscintilla";
    EMisureEControlli["tettiEdImperiali"] = "tettiEdImperiali";
    EMisureEControlli["elettrico"] = "elettrico";
    EMisureEControlli["pneumatico"] = "pneumatico";
    EMisureEControlli["idraulico"] = "idraulico";
    EMisureEControlli["ossigeno"] = "ossigeno";
    EMisureEControlli["matricolaAnalizzatore"] = "matricolaAnalizzatore";
    EMisureEControlli["scadenzaCalibrazione"] = "scadenzaCalibrazione";
    EMisureEControlli["monossido"] = "monossido";
    EMisureEControlli["metano"] = "metano";
    EMisureEControlli["idrogeno"] = "idrogeno";
    EMisureEControlli["ventilazione"] = "ventilazione";
    EMisureEControlli["predisposizione"] = "predisposizione";
    EMisureEControlli["presenzaTreppiede"] = "presenzaTreppiede";
    EMisureEControlli["piattaformeFisse"] = "piattaformeFisse";
    EMisureEControlli["varchi"] = "varchi";
    EMisureEControlli["imbracature"] = "imbracature";
    EMisureEControlli["personaleEsecutore"] = "personaleEsecutore";
    EMisureEControlli["sgomberoArea"] = "sgomberoArea";
    EMisureEControlli["attrezzature"] = "attrezzature";
    EMisureEControlli["superfici"] = "superfici";
    EMisureEControlli["combustibili"] = "combustibili";
    EMisureEControlli["ispezioneImmediata"] = "ispezioneImmediata";
    EMisureEControlli["ispezioneRitardata"] = "ispezioneRitardata";
    EMisureEControlli["pavPes"] = "pavPes";
    EMisureEControlli["formazioneUtilizzo"] = "formazioneUtilizzo";
    EMisureEControlli["dpiIii"] = "dpiIii";
    EMisureEControlli["sollevamento"] = "sollevamento";
    EMisureEControlli["confinati"] = "confinati";
    EMisureEControlli["taglio"] = "taglio";
    EMisureEControlli["inertizzazione"] = "inertizzazione";
    EMisureEControlli["pulizia"] = "pulizia";
    EMisureEControlli["infiammabili"] = "infiammabili";
})(EMisureEControlli = exports.EMisureEControlli || (exports.EMisureEControlli = {}));
var ESicurezzaAntincendio;
(function (ESicurezzaAntincendio) {
    ESicurezzaAntincendio["sprinklerManichetteEstintori"] = "sprinklerManichetteEstintori";
    ESicurezzaAntincendio["estintoriAddizionali"] = "estintoriAddizionali";
    ESicurezzaAntincendio["attrezzatureOperative"] = "attrezzatureOperative";
    ESicurezzaAntincendio["liquidiAccumuliDepositi"] = "liquidiAccumuliDepositi";
    ESicurezzaAntincendio["atmosferaEsplosiva"] = "atmosferaEsplosiva";
    ESicurezzaAntincendio["pavimenti"] = "pavimenti";
    ESicurezzaAntincendio["pavimentiCombustibili"] = "pavimentiCombustibili";
    ESicurezzaAntincendio["materialiStoccaggiCombustibili"] = "materialiStoccaggiCombustibili";
    ESicurezzaAntincendio["apertureCoperte"] = "apertureCoperte";
    ESicurezzaAntincendio["teloniResistentiAlFuoco"] = "teloniResistentiAlFuoco";
    ESicurezzaAntincendio["paretiCombustibili"] = "paretiCombustibili";
    ESicurezzaAntincendio["materialeCombustibile"] = "materialeCombustibile";
    ESicurezzaAntincendio["attrezzatureMacchinariPulizia"] = "attrezzatureMacchinariPulizia";
    ESicurezzaAntincendio["serbatoiContenitoriSpurgati"] = "serbatoiContenitoriSpurgati";
    ESicurezzaAntincendio["servizioVigilanza"] = "servizioVigilanza";
    ESicurezzaAntincendio["estintoriServizioVigilanza"] = "estintoriServizioVigilanza";
    ESicurezzaAntincendio["addettiVigilanzaAddestrati"] = "addettiVigilanzaAddestrati";
    ESicurezzaAntincendio["estensioneServizioVigilanza"] = "estensioneServizioVigilanza";
})(ESicurezzaAntincendio = exports.ESicurezzaAntincendio || (exports.ESicurezzaAntincendio = {}));
